// src/layouts/show-detail/show-detail.tsx
import Anchor from "@a24/ui/Anchor";
import Icon from "@a24/ui/Icon";
import Link from "@a24/ui/Link";
import Richtext from "@a24/ui/Richtext";
import SanityImage from "@a24/ui/SanityImage";
import ShowRunLabel from "@a24/ui/ShowRunLabel";
import Title from "@a24/ui/Title";
import { jsx, jsxs } from "react/jsx-runtime";
var ShowDetail = ({
  className,
  cta,
  description,
  endDate,
  hasPerformances = false,
  id,
  image,
  labels = {
    backToShows: "Back to Shows",
    backToShowsDestination: "/shows",
    bookTickets: "Book Tickets"
  },
  sequence,
  showId,
  startDate,
  timelineId,
  title
}) => {
  const layoutName = "ShowDetail";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `grid grid-cols-12 gap-x-3 ${className} sm:gap-x-6 max-md:px-6 max-2xl:px-16`,
      "data-layout": layoutName,
      id: `${showId}|${id}`,
      children: [
        /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 pb-[6.25rem]", children: /* @__PURE__ */ jsxs("div", { className: "flex row gap-4 items-center w-fit", children: [
          /* @__PURE__ */ jsx(
            Link,
            {
              "aria-label": labels.backToShows,
              className: "button-tertiary",
              href: labels.backToShowsDestination || "/",
              tracking: {
                label: labels.backToShows,
                layout: "Show Detail"
              },
              children: /* @__PURE__ */ jsx(Icon, { name: "arrow-left" })
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "breadcrumb", children: labels.backToShows })
        ] }) }),
        title && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 sm:col-span-7", children: /* @__PURE__ */ jsx(
          Title,
          {
            className: "title-xl text-heritage-red-full pb-6",
            id: `${layoutName}_${sequence}_showHeading`,
            level: "h1",
            text: title
          }
        ) }),
        startDate && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 sm:col-span-7", children: /* @__PURE__ */ jsx(
          ShowRunLabel,
          {
            className: "label-md pb-8 sm:pb-12",
            endDate,
            id: `${layoutName}_${sequence}_showRun`,
            startDate
          }
        ) }),
        description && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 pb-14 sm:pb-[4.5rem] sm:col-span-7", children: /* @__PURE__ */ jsx(
          Richtext,
          {
            className: "freetext-richtext heading-sm",
            text: description
          }
        ) }),
        cta && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 pb-14 sm:pb-[4.5rem] sm:col-span-7", children: /* @__PURE__ */ jsxs(
          Link,
          {
            "aria-label": cta.label,
            className: "button-primary",
            href: cta.destination || "/",
            tracking: {
              label: cta.label,
              layout: "Show Detail"
            },
            children: [
              cta.label,
              cta.isExternal && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "arrow-right",
                  className: "ml-2 h-[0.75em]",
                  SVGClassName: "h-[100%] w-auto"
                }
              )
            ]
          }
        ) }),
        hasPerformances && !cta && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 pb-14 sm:pb-[4.5rem] sm:col-span-7", children: /* @__PURE__ */ jsx(Anchor, { label: labels?.bookTickets, target: timelineId }) }),
        image && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 row-start-2 max-sm:pb-8 sm:col-span-4 sm:col-start-9 sm:row-span-5 sm:row-start-2 lg:col-span-3 lg:col-start-10", children: /* @__PURE__ */ jsx(
          SanityImage,
          {
            className: "w-[100%]",
            sanityImageSourceData: image,
            width: 620,
            height: 930
          }
        ) })
      ]
    }
  );
};
var show_detail_default = ShowDetail;

export {
  show_detail_default
};
